<template>
  <div>
    <el-card>
      <alter-form labelWidth="180px" :watchImageVisible="false" @handleChange="handleChange" @formSubmit="formSubmit" :formData="formData" :collapseLength="collapseLength"></alter-form>
    </el-card>
  </div>
</template>

<script>
import Logic from './index.js'
export default Logic
</script>

<style lang="scss" scope>
@import './index.scss';
</style>
